export default __webpack_public_path__ + "static/media/mona-loading-dark.a73a63d1.gif";